import { ShieldAlert } from "lucide-react";
import { Modal } from "../../components/ui/modal";
import type { ComplianceMatch } from "./types";

/** Shown instead of dialing when the suppression list blocks this contact. */
export function ComplianceBlockedModal({ leadName, matches, onClose }: {
  leadName: string;
  matches: ComplianceMatch[];
  onClose: () => void;
}) {
  return (
    <Modal
      title="Calling restricted"
      subtitle={`${leadName} is on the suppression list — the call was not placed.`}
      onClose={onClose}
      width="max-w-md"
      footer={
        <button onClick={onClose} className="rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-white hover:bg-brand-hover">
          Understood
        </button>
      }
    >
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
        <div className="space-y-1.5 text-sm text-ink-2">
          {matches.map((m, i) => (
            <p key={i}>
              <span className="font-semibold text-ink">{m.reason}</span>
              {m.createdAt && <span className="text-ink-3"> · opted out {new Date(m.createdAt).toLocaleDateString()}</span>}
            </p>
          ))}
          {matches.length === 0 && <p>Suppressed contact.</p>}
          <p className="pt-1 text-xs text-ink-3">Ask a manager to remove them from the DND list to call. This blocked attempt is logged in the lead&apos;s history.</p>
        </div>
      </div>
    </Modal>
  );
}
